import { render, staticRenderFns } from "./FeedbackFilters.vue?vue&type=template&id=0b76159a&lang=pug&"
import script from "./FeedbackFilters.vue?vue&type=script&lang=js&"
export * from "./FeedbackFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports